import Fuse from 'fuse.js'

export function formatPhoneNumber(phoneNumberString) {
    if (!phoneNumberString) {
        return ""
    }
    const extArray = phoneNumberString.split('ext')
    var cleaned = ('' + extArray[0]).replace(/\D/g, '');

    var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        var intlCode = (match[1] ? '+1 ' : '');
        var formattedPhoneNumber = [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
        if (extArray[1]) {
            formattedPhoneNumber += " ext " + extArray[1]
        }
        return formattedPhoneNumber;
    }
    return null;
}

export const searchBarFilter = (tableData, searchText, setFilteredData) => {

    if (searchText.length === 0) {
        setFilteredData(tableData)
        return
    }
    const fuseOptions = {
        // isCaseSensitive: false,
        // includeScore: false,
        // shouldSort: true,
        // includeMatches: false,
        // findAllMatches: false,
        // minMatchCharLength: 1,
        // location: 0,
        // threshold: 0.6,
        // distance: 100,
        // useExtendedSearch: false,
        // ignoreLocation: false,
        // ignoreFieldNorm: false,
        // fieldNormWeight: 1,
        keys: [
            "formData.firstName",
            "formData.lastName",
            // "formData.city",
            // "formData.stateProvince",
            // "formData.country"
        ]
    };
    const fuse = new Fuse(tableData, fuseOptions);
    setFilteredData(fuse.search(searchText).map((item) => item.item))
}

export const prefixDecoder = (prefix) => {
    switch (prefix) {
        case 'mr':
            return "Mr "

        case 'ms':
            return "Ms "

        case 'dr':
            return "Dr "

        case 'prof':
            return "Prof "


        default:
            return ""
    }
}

export const clearanceDecoder=(security_clearance)=>{
    switch (security_clearance) {
        case "top_secret_sensitive":
           return "Top Secret, Sensitive Compartmented Information"    
        case "top_secret":
            return "Top Secret"
        case "confidential":
            return "Confidential"
        case "secret": 
            return "Secret"
        default:
            return ""
    }
}